<template>
  <div
    class="widgetBox"
  >
    <div class="widgetTitle">
      <div style="display:flex">
        <v-icon color="black">
          mdi-drag
        </v-icon>
        <v-toolbar-title
          style="font-weight: 600; padding: 10px;"
        >
          {{ $t(`siteDashboard.${widgetTitle}`) }}
        </v-toolbar-title>
      </div>
      <v-btn
        icon
        @click="onclickClose(widget.i)"
      >
        <v-icon color="black">
          close
        </v-icon>
      </v-btn>
    </div>
    <div class="widgetBody">
      <component
        :is="selectedWidget"
        v-if="selectedWidget"
        :w="w"
        :h="h"
        :widget="widget"
        :minW="minW"
        :minH="minH"
        hideTitle
        @updateWidgetInLayout="updateWidgetInLayout"
      />
      <p v-else>
        {{ $t('siteDashboard.unknownWidget') }} : {{ widget.name }}
      </p>
    </div>
  </div>
</template>

<script>
import Notifications from '@/views/sites/siteDashboard-old/Notifications/';
// import Inventory from '@/views/sites/siteDashboard-old/Inventory/';
import Calendar from '@/views/sites/siteDashboard-old/SiteCalendar/';
import LatestWorkOrder from '@/views/sites/siteDashboard-old/LatestWorkOrder/index.vue';
import LatestReports from '@/views/sites/siteDashboard-old/LatestReports/';
import Appointment from '@/views/sites/siteDashboard-old/SiteCalendar/Appointment.vue';
import Graphics from '@/views/sites/siteDashboard-old/GraphicCarrousel.vue';
import E4 from '@/views/sites/siteDashboard/components/E4/index.vue';
import LastLabReports from '@/views/sites/siteDashboard-old/LastLabReports/LastLabReports.vue';
import UnbilledWorkOrder from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/index.vue';
import ServiceCalls from '@/views/sites/siteDashboard-old/ServiceCalls/index.vue';
import { mapGetters } from 'vuex';
import roles from '@/constants/roles';

export default {
    name: 'WidgetBox',
    components: {
        Notifications,
        // Inventory,
        LatestReports,
        LatestWorkOrder,
        UnbilledWorkOrder,
        Appointment,
        Graphics,
        Calendar,
        E4,
        LastLabReports,
        ServiceCalls,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
        w: {
            type: Number,
            required: true,
        },
        h: {
            type: Number,
            required: true,
        },
        minW: {
            type: Number,
            required: true,
        },
        minH: {
            type: Number,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['hasRole']),
        selectedWidget() {
            const widgetMap = {
                Notifications,
                // Inventory,
                Calendar,
                LatestReports,
                LatestWorkOrder,
                UnbilledWorkOrder,
                Appointment,
                Graphics,
                E4,
                LastLabReports,
            };
            if (!this.hasRole(roles.ROLE_OPERATOR.value)) {
                widgetMap.ServiceCalls = ServiceCalls;
            }
            return widgetMap[this.widget.name] || null;
        },
        widgetTitle() {
            return this.widget.name.charAt(0).toLowerCase() + this.widget.name.slice(1) || '';
        },
    },
    methods: {
        onclickClose(i) {
            this.$emit('close', i);
        },

        componentName(item) {
            if (item && this.layout.length) {
                const dashboardTemplateType = this.layout.find(obj => obj.i === item);
                return dashboardTemplateType.name.charAt(0).toLowerCase() + dashboardTemplateType.name.slice(1);
            }
            return '';
        },
        updateWidgetInLayout(widget) {
            this.$emit('updateWidgetInLayout', widget);
        },
    },
};
</script>

<style lang="scss">
  .widgetBox {
    flex: 1;
    flex-direction: column;
    background: #FFF;
    width: 100%;
    padding: 3px;
    overflow: auto;
   }
   .widgetTitle {
    display:flex;
    justify-content: space-between;
    padding: 10px;
   }

</style>
